import React, { useState, useEffect, useRef } from "react";
import { FiHeart, FiMusic, FiUsers, FiTrendingUp } from "react-icons/fi";

import MainContainer from "../../../components/utils/MainContainer";
import Particles from "../../../components/utils/Particles";
import {
  Container,
  PageHeader,
  PageSubtitle,
  PageTitle,
  Section,
  SectionText,
  SectionTitle,
  StatCard,
  StatIcon,
  StatLabel,
  StatNumber,
  StatsGrid,
} from "./AboutPage.styles";
import ContactSectionComponent from "../../../components/utils/ContactSectionComponent";
import { FaMusic } from "react-icons/fa";

// Custom hook for counter animation
const useCounterAnimation = (end, duration = 2000) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);

  useEffect(() => {
    if (!countRef.current) {
      countRef.current = { start: 0, startTime: Date.now() };
    }

    const animate = () => {
      const now = Date.now();
      const elapsed = now - countRef.current.startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation
      const easeOutCubic = 1 - Math.pow(1 - progress, 3);
      const currentCount = Math.floor(easeOutCubic * end);
      
      setCount(currentCount);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    const timer = setTimeout(() => {
      animate();
    }, 200); // Small delay before starting animation

    return () => clearTimeout(timer);
  }, [end, duration]);

  return count;
};

// Animated Counter Component
const AnimatedCounter = ({ end, suffix = "" }) => {
  const count = useCounterAnimation(parseInt(end.toString().replace(/\D/g, '')), 2000);
  
  return (
    <span>
      {count.toLocaleString()}{suffix}
    </span>
  );
};

export default function AboutPage() {
  return (
    <MainContainer>
      <Particles />
      <Container>
        <PageHeader>
          <PageTitle>O nama</PageTitle>
          <PageSubtitle>
            Posvećeni smo promociji srpske muzičke scene i povezivanju fanova sa
            njihovim omiljenim bendovima kroz autentične proizvode.
          </PageSubtitle>
        </PageHeader>

        {/* Naša priča */}

        <Section>
          <SectionTitle>
            <FiMusic />
            Naša priča
          </SectionTitle>
          <SectionText>
            МРЧ je nastao iz ljubavi prema domaćoj muzici i želje da pomognemo
            lokalnim bendovima da se povežu sa svojim fanovima. Osnovani 2020.
            godine u Kragujevcu, počeli smo kao mala grupica ljubitelja muzike
            sa velikim snovima.
          </SectionText>
          <SectionText>
            Danas smo postali vodeća platforma za originalnu merchandise robu
            srpskih bendova. Radimo direktno sa umetnicima da im pomognemo da
            prošire svoju publiku i ostvare dodatni prihod kroz prodaju
            kvalitetnih proizvoda.
          </SectionText>

          <StatsGrid>
            <StatCard whileHover={{ y: -5 }} transition={{ duration: 0.3 }}>
              <StatIcon>
                <FiUsers />
              </StatIcon>
              <StatNumber><AnimatedCounter end={10} suffix="+" /></StatNumber>
              <StatLabel>Partnera bendova</StatLabel>
            </StatCard>
            <StatCard whileHover={{ y: -5 }} transition={{ duration: 0.3 }}>
              <StatIcon>
                <FaMusic />
              </StatIcon>
              <StatNumber><AnimatedCounter end={100} suffix="+" /></StatNumber>
              <StatLabel>Koncerata</StatLabel>
            </StatCard>
            <StatCard whileHover={{ y: -5 }} transition={{ duration: 0.3 }}>
              <StatIcon>
                <FiHeart />
              </StatIcon>
              <StatNumber><AnimatedCounter end={5000} suffix="+" /></StatNumber>
              <StatLabel>Zadovoljnih kupaca</StatLabel>
            </StatCard>
            <StatCard whileHover={{ y: -5 }} transition={{ duration: 0.3 }}>
              <StatIcon>
                <FiTrendingUp />
              </StatIcon>
              <StatNumber><AnimatedCounter end={5} /></StatNumber>
              <StatLabel>Godina iskustva</StatLabel>
            </StatCard>
          </StatsGrid>
        </Section>

        {/* Kontakt */}
        <ContactSectionComponent />
      </Container>
    </MainContainer>
  );
}
